export default "__VITE_ASSET__D9K9h9Zo__"